import _ from "underscore";
import UserSelectorEmptyMessageBuilder from "./UserSelectorEmptyMessageBuilder";

export default function AccessRightEmptyMessageBuilder(userSelectorGroupsStrategy, accessRight)
{
    UserSelectorEmptyMessageBuilder.call(this, userSelectorGroupsStrategy);
    this.accessRight = accessRight;
}

AccessRightEmptyMessageBuilder.prototype = _.create(UserSelectorEmptyMessageBuilder.prototype, {
    createMessages: function()
    {
        UserSelectorEmptyMessageBuilder.prototype.createMessages.call(this);

        this.messages["noAccessRightGrantedUsers"] = this.accessRight.getNoAccessRightGrantedUsersMessage();
        this.messages["noEnabledAccessRightGrantedUsers"] = this.accessRight.getNoEnabledAccessRightGrantedUsersMessage();
        this.messages["noSelectedNodesHasDisabledOrWithoutAccessRight"] = this.accessRight.getNoSelectedNodesHasDisabledOrWithoutAccessRightMessage();
    }
});



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/emptyMessagesBuilders/AccessRightEmptyMessageBuilder.js